import { MdCheck, MdCancel } from 'react-icons/md'

import { colors } from 'shared/styles/colors'
import styled from 'styled-components'

export const Icon = styled.img`
  width: 70px;
  height: 70px;
`
export const StyledCheck = styled(MdCheck)`
  color: ${colors.blue};
  font-size: 80px !important;
  padding: 10px 10px 10px 10px;
  border: 3px solid ${colors.blue};
  border-radius: 50%;
`

export const StyledCancel = styled(MdCancel)`
  color: ${colors.red};
  font-size: 80px !important;
  padding: 10px 10px 10px 10px;
  border-radius: 50%;
`
